module.exports = __webpack_public_path__ + "img/2134.e1761db1.gif";